import {
  PromotionalDollarQueryQuery,
  PromotionalDollarQueryQueryVariables,
  UserPromotionCodeStatus,
} from "@ctypes";
import { PROMOTIONAL_DOLLAR_QUERY } from "@graphql/queries";
import { useQuery } from "@hooks/apollo";
import { convertCentsToDollar } from "@utils";

export const usePromotionalDollarQuery = () => {
  const { data, ...rest } = useQuery<
    PromotionalDollarQueryQuery,
    PromotionalDollarQueryQueryVariables
  >(PROMOTIONAL_DOLLAR_QUERY);

  const promotionalBalance = convertCentsToDollar(data?.promotionalDollarBalanceInCents);

  const promoCodeRedemptions = data?.userPromotionCodeRedemptions;

  const pendingBalance =
    promoCodeRedemptions
      ?.filter(
        (p) =>
          p?.status === UserPromotionCodeStatus.Processing ||
          p?.status === UserPromotionCodeStatus.New,
      )
      .reduce((sum, p) => sum + (p?.promotionCode?.amountOff ?? 0), 0) ?? 0;

  const hasNoBalance = Boolean(promotionalBalance === 0 && pendingBalance === 0);

  return {
    promotionalBalance,
    pendingBalance,
    promoCodeRedemptions,
    hasNoBalance,
    ...rest,
  };
};
